import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Image = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M40.889 5.56H3.206C1.403 5.56 0 6.963 0 8.767v26.465c0 1.804 1.503 3.208 3.207 3.208h37.581c1.804 0 3.207-1.504 3.207-3.208V8.767c.1-1.804-1.403-3.207-3.106-3.207ZM1.803 8.767c0-.802.601-1.403 1.403-1.403h37.581c.802 0 1.403.601 1.403 1.403V30.42l-8.318-8.32c-.4-.3-.902-.3-1.302 0l-7.116 7.117-12.126-12.23c-.2-.2-.401-.3-.601-.3-.2 0-.502.1-.702.3L1.804 27.212V8.767Zm40.488 26.465c0 .802-.602 1.403-1.404 1.403H3.208c-.802 0-1.403-.601-1.403-1.403v-5.413l10.823-10.827 12.227 12.23c.4.3.902.3 1.303 0l7.115-7.117 8.92 8.921v2.206h.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M25.856 13.379a2.481 2.481 0 0 0-2.505 2.506 2.481 2.481 0 0 0 2.505 2.506 2.481 2.481 0 0 0 2.505-2.506 2.481 2.481 0 0 0-2.505-2.506Zm-4.41 2.506c0-2.406 1.905-4.411 4.41-4.411 2.405 0 4.41 1.905 4.41 4.41 0 2.507-1.905 4.411-4.41 4.411-2.405 0-4.41-2.005-4.41-4.41Z"
  })));
});
Image.displayName = 'Image';
Image.defaultProps = {
  'aria-label': 'Image'
};
export default Image;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Image.js
// module id = 3548
// module chunks = 11